import { APP_TYPE } from 'gatsby-env-variables'

export default APP_TYPE === 'organic'
